// extracted by mini-css-extract-plugin
export var addButton = "_fi-0";
export var border = "_fi-8";
export var check = "_fi-h";
export var danger = "_fi-6";
export var dropdownContainer = "_fi-1";
export var editModalBody = "_fi-j";
export var footerContainer = "_fi-i";
export var fullWidth = "_fi-a";
export var hide = "_fi-9";
export var icon = "_fi-3";
export var input = "_fi-7";
export var inputFlex = "_fi-b";
export var inputWrapper = "_fi-c";
export var manualFocus = "_fi-5";
export var optionButton = "_fi-4";
export var pillWrapper = "_fi-e";
export var pointer = "_fi-2";
export var showOverflow = "_fi-f";
export var tagsFlex = "_fi-d";
export var xButton = "_fi-g";